<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="标签名称" :value="1"></el-option>
                            <el-option label="标签ID" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-cascader style="width:100%" v-model="cascadeValue" :options="cascade"
                        :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'childList' }" clearable
                        size="small" placeholder="对象/一级标签/二级标签" filterable>
                    </el-cascader>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sort" placeholder="请选择" size="small">
                        <el-option label="优先展示最新修改的" :value="1"></el-option>
                        <el-option label="优先展示最新创建的" :value="2"></el-option>
                        <el-option label="优先展示最早创建的" :value="3"></el-option>
                        <el-option label="优先展示使用次数最多的" :value="4"></el-option>
                        <el-option label="优先展示使用次数最少的" :value="5"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/label/edit')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="$refs.add.show()">新增标签</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="id" label="标签ID">
                </el-table-column>
                <el-table-column prop="object" label="对象" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="firstLevel" label="一级分类" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="secondLevel" label="二级分类" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="name" label="标签名称" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="coverage" label="覆盖率" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{scope.row.coverage}}%
                    </template>
                </el-table-column>
                <el-table-column prop="processType" label="加工类型" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="valueType" label="取值类型" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="updateCycle" label="更新周期" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="modifyTime" label="最近修改" min-width="150">
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="150">
                </el-table-column>
                <el-table-column prop="useNum" label="使用次数">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button v-if="$utils.have('/label/edit')" type="text" size="small"
                            @click="$refs.add.show(scope.row.id)">编辑</el-button>
                        <el-button v-if="$utils.have('/label/value/list')" type="text" size="small"
                            @click="valueList(scope.row.id)">值字典</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <add-label ref="add" @onUpdate="getDataList" :cascade="cascade"></add-label>
    </div>
</template>

<script>
import AddLabel from './components/AddLabel.vue'
const defaultParams = {
    pageNo: 1,
    firstLevel: "",
    secondLevel: "",
    object: "",
    searchType: 1, //1：名称 2：id
    searchValue: "",
    sort: 1,
}
export default {
    components: { AddLabel },
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                firstLevel: parseInt(this.$route.query.firstLevel) || "",
                secondLevel: parseInt(this.$route.query.secondLevel) || "",
                object: parseInt(this.$route.query.object) || "",
                sort: parseInt(this.$route.query.sort || 1),
            },
            listLoading: true,
            cascade: [],
            cascadeValue: []
        }
    },
    created() {
        if (this.params.object) {
            this.cascadeValue.push(this.params.object)
        }
        if (this.params.firstLevel) {
            this.cascadeValue.push(this.params.firstLevel)
        }
        if (this.params.secondLevel) {
            this.cascadeValue.push(this.params.secondLevel)
        }
        this.getCascade();
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //标签级联关系
        getCascade() {
            this.$request({
                url: "/label/cascade",
                method: "POST",
                data: {},
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.cascade = result;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                object: this.cascadeValue[0] || '',
                firstLevel: this.cascadeValue[1] || '',
                secondLevel: this.cascadeValue[2] || '',
            }
            this.$request({
                url: "/label/list",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.data = null;
                        this.dataList = [];
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.cascadeValue = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        // 值字典
        valueList(id){
            this.$router.push({
                path: `/label/dictionary/value/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        {
                            ...this.params,
                        }
                    ),
                },
            });
        }
    }
}
</script>
<style lang="scss" scoped>

</style>